import Button from 'components/Button';
import Modal from 'components/Modal/Modal';
import { useLanguage } from 'context/AppContext';
import React from 'react';

interface RejectConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onReject: () => void;
}

const RejectConfirmationModal: React.FC<RejectConfirmationModalProps> = ({ open, onClose, onReject }) => {
  const [language] = useLanguage();

  return (
    <Modal open={open} close={onClose} width="30rem">
      <h2>{language.Sato.updateStatus.rejectSet}</h2>
      <p>{language.Sato.updateStatus.rejectSetConfirm}</p>
      <Button fullWidth onClick={onReject}>
        {language.ConfirmModal.confirm}
      </Button>
    </Modal>
  );
};

export default RejectConfirmationModal;
